<template>
  <div id="container">
    <div class="item-box-content" style="padding-bottom:0px;">
      <div class="title-font-style">
        <span>备货信息</span>
      </div>
      <el-form class="details-line-height" style="padding:20px 30px 0 30px">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="工单编号：">
              {{
              orderContractStockup.stockupCode
              }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="备货方式：">
              {{
              orderContractStockup.stockupType
              }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="请求备货时间：">{{ orderContractStockup.createDate | dateFilterNum }}</el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" v-show="this.$route.query.stockUpType !== '直发备货'">
          <el-col :span="8">
            <el-form-item label="备货仓库：">
              {{
              orderContractStockup.storageName || "--"
              }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="仓库地址：">
              {{
              orderContractStockup.storageAddress||'--'
              }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系电话：">
              {{
              orderContractStockup.storagePhone||'--'
              }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="预计发货时间：">
              {{
              orderContractStockup.deliveryTime | dateFilter
              }}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="item-box-content" :style="{minHeight: tableHeight+'px'}">
      <div class="title-font-style">
        <span>配货方案</span>
      </div>
      <div v-if="$route.query.stockUpType === '入库备货'&&orderContractStockupStorageVoList.length!==0">
        <p style="text-align:center;font-size:16px">仓库备货区</p>
        <el-table
          border
          ref="tableRef"
          :data="orderContractStockupStorageVoList"
          tooltip-effect="dark"
          :header-cell-style="tableHeader"
          max-height="378"
        >
          <template slot="empty">
            <i class="el-icon-refresh-right" style="padding-right:10px;"></i>
            <span>暂无产品信息</span>
          </template>
          <el-table-column show-overflow-tooltip prop="brandName" label="品牌"></el-table-column>
          <el-table-column show-overflow-tooltip prop="seriesName" label="系列"></el-table-column>
          <el-table-column show-overflow-tooltip prop="proName" label="产品名称"></el-table-column>
          <el-table-column show-overflow-tooltip prop="proType" label="型号">
            <template slot-scope="scope">
              <div
                class="approval line-limit-length"
                @click="onEdit(scope.row)"
              >{{ scope.row.proType }}</div>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="orderNumber" label="订货号"></el-table-column>
          <el-table-column show-overflow-tooltip prop="cbUnit" label="单位"></el-table-column>
          <el-table-column show-overflow-tooltip prop="count" label="备货数量"></el-table-column>
          <el-table-column show-overflow-tooltip prop="cbPrice" label="采购单价">
            <template slot-scope="scope">{{ scope.row.cbPrice|priceFilterNum }}</template>
          </el-table-column>
          <el-table-column prop="total" label="采购总价">
            <template slot-scope="scope">{{ scope.row.total |priceFilterNum }}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="cbPriceSource" label="询价来源">
            <template slot-scope="scope">
              <span v-if="scope.row.cbPriceSource === 1">系统</span>
              <span v-else-if="scope.row.cbPriceSource === 2">人工</span>
              <span v-else-if="scope.row.cbPriceSource === 3">特价审批</span>
              <span v-else-if="scope.row.cbPriceSource === 4">其他</span>
              <span v-else-if="scope.row.cbPriceSource === 5">库存</span>
              <span v-else>暂无</span>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="storageName" label="所在仓库"></el-table-column>
          <el-table-column show-overflow-tooltip prop="distributionType" label="备货方式 ">
            <template slot-scope="scope">{{ scope.row.distributionType === 1 ? "仓库备货" : "调拨配货" }}</template>
          </el-table-column>
          <el-table-column prop="count" label="锁库数量"></el-table-column>
        </el-table>
      </div>
      <div class="operation" v-show="orderContractStockupPurchaseVoList.length !==0">
        <p style="text-align:center;font-size:16px">采购备货区</p>
        <el-table
          border
          ref="tableRef"
          :data="orderContractStockupPurchaseVoList"
          tooltip-effect="dark"
          max-height="378"
          :header-cell-style="tableHeader"
        >
          <template slot="empty">
            <i class="el-icon-refresh-right" style="padding-right:10px;"></i>
            <span>暂无产品信息</span>
          </template>
          <el-table-column show-overflow-tooltip prop="brandName" label="品牌"></el-table-column>
          <el-table-column prop="seriesName" show-overflow-tooltip label="系列"></el-table-column>
          <el-table-column prop="proName" show-overflow-tooltip label="产品名称"></el-table-column>
          <el-table-column show-overflow-tooltip prop="proType" label="型号">
            <template slot-scope="scope">
              <div
                class="approval line-limit-length"
                @click="onEdit(scope.row)"
              >{{ scope.row.proType }}</div>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="orderNumber" label="订货号"></el-table-column>
          <el-table-column show-overflow-tooltip prop="cbUnit" label="单位"></el-table-column>
          <el-table-column show-overflow-tooltip prop="stockupCount" label="备货数量"></el-table-column>
          <el-table-column show-overflow-tooltip prop="cbPrice" label="采购单价">
            <template slot-scope="scope">{{ scope.row.cbPrice |priceFilterNum }}</template>
          </el-table-column>
          <el-table-column prop="total" label="采购总价">
            <template slot-scope="scope">{{ scope.row.total |priceFilterNum }}</template>
          </el-table-column>
          <el-table-column prop="cbPriceSource" label="询价来源">
            <template slot-scope="scope">
              <span v-if="scope.row.cbPriceSource === 1">系统</span>
              <span v-else-if="scope.row.cbPriceSource === 2">人工</span>
              <span v-else-if="scope.row.cbPriceSource === 3">特价审批</span>
              <span v-else-if="scope.row.cbPriceSource === 4">其他</span>
              <span v-else-if="scope.row.cbPriceSource === 5">库存</span>
              <span v-else>暂无</span>
            </template>
          </el-table-column>
          <el-table-column prop="suName" show-overflow-tooltip label="询价供应商" width="100px"></el-table-column>
          <el-table-column show-overflow-tooltip prop="cbExtimeValue" label="货期">
            <template slot-scope="scope">
              <span>{{ scope.row.cbExtimeValue+"天" }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="stockupCount" label="采购数量"></el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
import { queryByOrderContractStockupStorage } from '@/api/purchase/waitAllocateCargolist'
import { formatDate } from '@/util/tool'

export default {
  data () {
    return {
      tableHeight: window.innerHeight - 380,
      status: ['平台渠道', '供应商', '厂家', '经销商'],
      orderContractStockup: {},
      waitList: [], // 待配货清单
      orderContractStockupStorageVoList: [], // 仓库备货区
      orderContractStockupPurchaseVoList: []
    }
  },
  mounted () {
    if (this.$route.query.ocsId) {
      queryByOrderContractStockupStorage(this.$route.query.ocsId)
        .then((res) => {
          if (res.data.code === 200) {
            this.orderContractStockup = res.data.obj.orderContractStockup
            this.orderContractStockupStorageVoList =
             res.data.obj.orderContractStockupStorageVoList
            if (this.orderContractStockupStorageVoList.length === 0) {
              this.orderContractStockupStorageVoList = []
            }
            this.orderContractStockupPurchaseVoList =
             res.data.obj.orderContractStockupPurchaseVoList
          }
        })
        .catch((err) => {
          console.log(err)
        })
    } else {
      queryByOrderContractStockupStorage(this.$route.query.psbId)
        .then((res) => {
          if (res.data.code === 200) {
            this.orderContractStockup = res.data.obj.orderContractStockup
            this.orderContractStockupStorageVoList =
             res.data.obj.orderContractStockupStorageVoList
            if (this.orderContractStockupStorageVoList.length === 0) {
              this.orderContractStockupStorageVoList = []
            }
            this.orderContractStockupPurchaseVoList =
             res.data.obj.orderContractStockupPurchaseVoList
          }
        })
        .catch((err) => {
          console.log(err)
        })
    }
  },
  methods: {
    onEdit (row) {
      this.$router.push({
        name: 'productDetails',
        query: { id: row.proId }
      })
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 库存详情查看
    onSee () {
      this.$refs.distributionInventoryDetailsDrawerRefs.onInitial()
    }
  },
  filters: {
    dateFilter, dateFilterNum
  }
}
function dateFilter (time) {
  if (time === null) {
    return ''
  } else {
    const date = new Date(time)
    return formatDate(date, 'yyyy-MM-dd')
  }
}
function dateFilterNum (time) {
  if (time === null) {
    return ''
  } else {
    const date = new Date(time)
    return formatDate(date, 'yyyy-MM-dd hh:mm')
  }
}
</script>
